import { VoiceSubscriptionType } from '@sales/modules/subscription/models/offerings-response.model';
import { SubscriptionType } from '@sales/modules/details/models/subscription-type';
import { Price } from './price.model';

export enum SubscriptionStatusSimplified {
  Active = 'Active',
  Processing = 'Processing',
  Unknown = 'Unknown',
}

export enum SubscriptionStatus {
  InvalidStatus = 'InvalidStatus',
  Assigning = 'Assigning',
  Active = 'Active',
  Terminating = 'Terminating',
  Terminated = 'Terminated',
  ChangePending = 'ChangePending',
  ModifyPending = 'ModifyPending',
  TerminatePending = 'TerminatePending',
  UndoTerminatePending = 'UndoTerminatePending',
  Suspended = 'Suspended',
  Frozen = 'Frozen',
  LostStolenFrozen = 'LostStolenFrozen',
  Unknown = 'Unknown',
}

export enum SubscriptionFamilyType {
  VoiceB2BAksessnummerMobil = 'VoiceB2BAksessnummerMobil',
  VoiceB2BAksessnummerMobilBasisTotal = 'VoiceB2BAksessnummerMobilBasisTotal',
}

export enum SubscriptionStatusFrozenSuspendedText {
  Suspended = 'Sperret',
  Frozen = 'Fryst',
  LostStolenFrozen = 'Mistet/Stjålet',
}

export enum EuDataQuota {
  IncludedInMainQuota = 'IncludedInMainQuota',
  SeparateQuota = 'SeparateQuota',
  NoQuota = 'NoQuota',
  Unknown = 'Unknown',
}

export enum RolloverGiftingCapability {
  DonateAndReceive = 'DonateAndReceive',
  DonateOnly = 'DonateOnly',
  ReceiveOnly = 'ReceiveOnly',
  NoGifting = 'NoGifting',
  Unknown = 'Unknown',
}

export enum ServiceCompatability {
  Unknown = 'Unknown',
  Available = 'Available',
  NotAvailable = 'NotAvailable',
  NotAvailableDueToSubscriptionSize = 'NotAvailableDueToSubscriptionSize',
  NotAvailableDueToBliKjent = 'NotAvailableDueToBliKjent',
  Required = 'Required',
  NotAvailableDueToSubscriptionType = 'NotAvailableDueToSubscriptionType',
}

export interface SubscriptionDetailsSimplified {
  subscriptionId: number;
  status: SubscriptionStatusSimplified;
  subscriptionFamilyType: SubscriptionFamilyType;
  canEdit: boolean;
  customerId: string;
}

export class Subscription {
  id: string;
  customerId: string;
  status: SubscriptionStatus;
  statusText: string;
  msisdn: string;
  icc: string;
  productName: string;
  activeSince: Date;
  endDate: Date;
  userName: string;
  userBirthDate: Date;
  isPortingNumber: boolean;
  portingTime: Date;
  portingMessagesLastStatus: string;
  datapackageName: string;
  isPrioritySubscription: boolean;
  isSecret: boolean;
  isReadOnly: boolean;
  euDataQuota: EuDataQuota;
  rolloverGiftingCapability: RolloverGiftingCapability;
  isRolloverEnabled: boolean;
  freeDataServiceCompatability: ServiceCompatability;
  subscriptionType: VoiceSubscriptionType;
  dataVolume: number;
  subscriptionFamily: SubscriptionFamily;
  commitmentPeriods: CommitmentPeriod[];
}

export class SubscriptionAdditionlService {
  productId: string;
  description: string;
  startDate: Date;
  status: string;
  isInCostControlBundle: string;
}

export class SubscriptionFamily {
  productType: SubscriptionType;
}

export class CommitmentPeriod {
  commitmentType: CommitmentType;
  bindingValue: string;
  expirationDate: Date;
  initialTerminationFee: Price;
  remainingTerminationFee: Price;
}

export enum CommitmentType {
  Unknown = 'Unknown',
  Avtalebinding = 'Avtalebinding',
  SimAvtaleBinding = 'SimAvtaleBinding',
  Terminalbinding = 'Terminalbinding',
  Utkjopsbinding = 'Utkjopsbinding',
  Tjenestebinding = 'Tjenestebinding',
}
